import React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";

const UserNotAssignedModal = ({ isOpen, toggle }) => {
  return (
    <Modal isOpen={isOpen} toggle={toggle} centered>
      <ModalHeader toggle={toggle}>Usuario no asignado</ModalHeader>
      <ModalBody>
        <p>
          El usuario con el que intenta iniciar sesión no está asignado a ningún
          cliente de esta aplicación. Por favor, inicie sesión con un cliente
          válido.
        </p>
      </ModalBody>
      <ModalFooter>
        <Button color="primary" onClick={toggle}>
          Aceptar
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default UserNotAssignedModal;
